import { CPC25_UNCLASSIFIED, type LegalCaseListItem } from '../../../../types/LegalCase';
import { debtorCell } from './debtorSummary';

// Modal do credor no relatório CPC 25 (AF-3817): a célula clicada (credor × polo × classificação)
// vira o filtro do page-list, o mesmo recorte do drill-down para a grid.
export interface CreditorCell {
    creditorEntity: string;
    pole: string;
    classification: string | null;
}

export interface CreditorCaseRow {
    id: string;
    externalCaseNumber: string;
    debtor: string;
    operations: string;
    classification: string;
    claimValue: string;
}

export const creditorCellFilters = (cell: CreditorCell): Record<string, string> => ({
    creditorEntity: cell.creditorEntity,
    pole: cell.pole,
    cpc25Classification: cell.classification ?? CPC25_UNCLASSIFIED,
});

export const toCreditorCaseRows = (items: LegalCaseListItem[]): CreditorCaseRow[] =>
    items.map((item) => ({
        id: item.id,
        externalCaseNumber: item.externalCaseNumber || '—',
        debtor: debtorCell(item.debtors).label,
        operations: item.operationsFormatted || '—',
        classification: item.cpc25ClassificationFormatted,
        claimValue: item.claimValueFormatted || '—',
    }));
